import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/store-stats/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const storeStats = {
  get: apiPathFunc(pathBase),
} as const;
